/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="education" size=32 />
 */
const Education = () => (
  <>
    <path
      d="M21.24 5.91V2.5C21.2399 2.34216 21.2025 2.18659 21.1307 2.04602C21.0589 1.90545 20.9549 1.78386 20.8271 1.6912C20.6993 1.59854 20.5514 1.53744 20.3955 1.51289C20.2396 1.48835 20.0801 1.50107 19.93 1.55L7.42004 5.91"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7751 1.07463C20.0001 1.00123 20.2394 0.982164 20.4733 1.01898C20.7072 1.05579 20.929 1.14744 21.1207 1.28643C21.3123 1.42542 21.4684 1.6078 21.576 1.81866C21.6837 2.02952 21.7399 2.26287 21.7401 2.49963V5.91C21.7401 6.18614 21.5162 6.41 21.2401 6.41C20.9639 6.41 20.7401 6.18614 20.7401 5.91V2.50036C20.74 2.42145 20.7213 2.34366 20.6854 2.27338C20.6495 2.20309 20.5975 2.14229 20.5336 2.09596C20.4697 2.04963 20.3958 2.01908 20.3178 2.00681C20.2412 1.99476 20.1629 2.00068 20.089 2.02409L7.58461 6.38214C7.32385 6.47302 7.03879 6.33531 6.94791 6.07455C6.85703 5.81379 6.99475 5.52873 7.25551 5.43785L19.7751 1.07463Z"
      fill="#002D55"
    />
    <path
      d="M24.84 5.91002V3.91002C24.8431 3.76003 24.8123 3.61129 24.7501 3.4748C24.6878 3.33832 24.5957 3.21758 24.4804 3.12155C24.3652 3.02551 24.2298 2.95664 24.0843 2.92002C23.9389 2.8834 23.787 2.87998 23.64 2.91002L7.42004 5.91002"
      fill="#B9DEFA"
    />
    <path
      d="M6.5 8.32997V6.90997C6.5 6.64476 6.60536 6.3904 6.79289 6.20287C6.98043 6.01533 7.23478 5.90997 7.5 5.90997H25.18C25.4452 5.90997 25.6996 6.01533 25.8871 6.20287C26.0746 6.3904 26.18 6.64476 26.18 6.90997V29.4C26.18 29.6652 26.0746 29.9195 25.8871 30.1071C25.6996 30.2946 25.4452 30.4 25.18 30.4H7.5C7.23478 30.4 6.98043 30.2946 6.79289 30.1071C6.60536 29.9195 6.5 29.6652 6.5 29.4V8.32997Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 6.40997C7.36739 6.40997 7.24022 6.46265 7.14645 6.55642C7.05268 6.65019 7 6.77737 7 6.90997V29.4C7 29.5326 7.05268 29.6598 7.14645 29.7535C7.24021 29.8473 7.36739 29.9 7.5 29.9H25.18C25.3126 29.9 25.4398 29.8473 25.5336 29.7535C25.6273 29.6598 25.68 29.5326 25.68 29.4V6.90997C25.68 6.77737 25.6273 6.65019 25.5336 6.55642C25.4398 6.46265 25.3126 6.40997 25.18 6.40997H7.5ZM6.43934 5.84931C6.72064 5.56801 7.10217 5.40997 7.5 5.40997H25.18C25.5778 5.40997 25.9594 5.56801 26.2407 5.84931C26.522 6.13062 26.68 6.51215 26.68 6.90997V29.4C26.68 29.7978 26.522 30.1793 26.2407 30.4606C25.9594 30.7419 25.5778 30.9 25.18 30.9H7.5C7.10218 30.9 6.72065 30.7419 6.43934 30.4606C6.15804 30.1793 6 29.7978 6 29.4V6.90997C6 6.51215 6.15804 6.13062 6.43934 5.84931Z"
      fill="#002D55"
    />
    <path
      d="M21.59 12.09H11.09C10.5653 12.09 10.14 12.5154 10.14 13.04V16.73C10.14 17.2547 10.5653 17.68 11.09 17.68H21.59C22.1147 17.68 22.54 17.2547 22.54 16.73V13.04C22.54 12.5154 22.1147 12.09 21.59 12.09Z"
      fill="#B9DEFA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.09 12.59C10.8415 12.59 10.64 12.7915 10.64 13.04V16.73C10.64 16.9786 10.8415 17.18 11.09 17.18H21.59C21.8385 17.18 22.04 16.9786 22.04 16.73V13.04C22.04 12.7915 21.8385 12.59 21.59 12.59H11.09ZM9.64001 13.04C9.64001 12.2392 10.2892 11.59 11.09 11.59H21.59C22.3908 11.59 23.04 12.2392 23.04 13.04V16.73C23.04 17.5308 22.3908 18.18 21.59 18.18H11.09C10.2892 18.18 9.64001 17.5308 9.64001 16.73V13.04Z"
      fill="#002D55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.64001 24.84C9.64001 24.5639 9.86387 24.34 10.14 24.34H22.54C22.8162 24.34 23.04 24.5639 23.04 24.84C23.04 25.1162 22.8162 25.34 22.54 25.34H10.14C9.86387 25.34 9.64001 25.1162 9.64001 24.84Z"
      fill="#002D55"
    />
  </>
)

export default Education
